import React from 'react';
import style from '../../assets/styles/CustomizedPrice.module.scss';

function CustomizedPrice({ item, onPriceChange, radioDisabled }) {
  const [formPriceOnScreen, setFormPriceOnScreen] = React.useState(() => {
    if (item.firstLabel && Number(item.firstPrice) > 0) {
      return `${item.firstPrice}-${item.firstLabel}-${item.firstCost || 0}`;
    }
    return '';
  });
  const [showCustomizedPrice, setShowCustomizedPrice] = React.useState(true);

  const validOptionsCount = [
    item.firstLabel && Number(item.firstPrice) > 0,
    item.secondLabel && Number(item.secondPrice) > 0,
    item.thirdLabel && Number(item.thirdPrice) > 0,
  ].filter(Boolean).length;

  const formClassName =
    validOptionsCount === 2
      ? style.twoColumns
      : validOptionsCount === 1
      ? style.oneColumn
      : style.threeColumns;

  const handleChange = (e) => {
    const [price, label, cost] = e.target.value.split('-');
    setFormPriceOnScreen(`${price}-${label}-${cost}`);

    onPriceChange({ price, label, cost });
  };

  React.useEffect(() => {
    console.log(item);
    if (!item.firstPrice) {
      setShowCustomizedPrice(false);
    }
  }, []);

  React.useEffect(() => {
    console.log(radioDisabled);
  }, [radioDisabled]);

  return (
    <div className={style.customizedPriceContainerForm}>
      {showCustomizedPrice && (
        <form className={formClassName}>
          {item.firstLabel && Number(item.firstPrice) > 0 && (
            <div>
              <label className={style.formCheckLabel}>
                {item.firstLabel}
                <input
                  disabled={radioDisabled}
                  className={style.formCheckInput}
                  id={`radio-${item.firstLabel}`}
                  value={`${item.firstPrice}-${item.firstLabel}-${item.firstCost || 0}`}
                  name="options"
                  type="radio"
                  checked={
                    formPriceOnScreen ===
                    `${item.firstPrice}-${item.firstLabel}-${item.firstCost || 0}`
                  }
                  onChange={handleChange}
                />
                R${item.firstPrice}
              </label>
            </div>
          )}
          {item.secondLabel && Number(item.secondPrice) > 0 && (
            <div>
              <label className={style.formCheckLabel}>
                {item.secondLabel}
                <input
                  disabled={radioDisabled}
                  className={style.formCheckInput}
                  id={`radio-${item.secondLabel}`}
                  name="options"
                  value={`${item.secondPrice}-${item.secondLabel}-${item.secondCost || 0}`}
                  checked={
                    formPriceOnScreen ===
                    `${item.secondPrice}-${item.secondLabel}-${item.secondCost || 0}`
                  }
                  type="radio"
                  onChange={handleChange}
                />
                R$ {item.secondPrice}
              </label>
            </div>
          )}
          {item.thirdLabel && Number(item.thirdPrice) > 0 && (
            <div>
              <label className={style.formCheckLabel}>
                {item.thirdLabel}
                <input
                  disabled={radioDisabled}
                  className={style.formCheckInput}
                  id={`radio-${item.thirdLabel}`}
                  value={`${item.thirdPrice}-${item.thirdLabel}-${item.thirdCost || 0}`}
                  name="options"
                  type="radio"
                  checked={
                    formPriceOnScreen ===
                    `${item.thirdPrice}-${item.thirdLabel}-${item.thirdCost || 0}`
                  }
                  onChange={handleChange}
                />
                R${item.thirdPrice}
              </label>
            </div>
          )}
        </form>
      )}
    </div>
  );
}
export default CustomizedPrice;
